/**
 * Change Fields breadcrumb origins. Built on the generic `from`-origin helpers in
 * `breadcrumbOrigin.ts`; this module only owns the Change-Fields-specific matcher table.
 */
import { type OriginMatcher, createOriginParser } from "./breadcrumbOrigin";

export { appendCurrentLocationAsFrom } from "./breadcrumbOrigin";

// Order matters: the combined-page Org Chart tab must match before the Directory path.
const ORIGIN_MATCHERS: OriginMatcher[] = [
	{ match: "tab=org-chart", label: "Org-Chart" },
	{ match: "/org-chart", label: "Org-Chart" },
	{ match: "/directory", label: "Directory" },
];

export const CHANGE_FIELDS_DEFAULT_ORIGIN = {
	href: "/directory?tab=org-chart",
	label: "Org-Chart",
} as const;

export type ChangeFieldsOrigin = {
	from: string;
	label: string;
};

export const parseChangeFieldsOrigin = createOriginParser(ORIGIN_MATCHERS, CHANGE_FIELDS_DEFAULT_ORIGIN);
